import { render, staticRenderFns } from "./AdminProviderDetails.vue?vue&type=template&id=3779579a&scoped=true&"
import script from "./AdminProviderDetails.vue?vue&type=script&lang=ts&"
export * from "./AdminProviderDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3779579a",
  null
  
)

export default component.exports